var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useMemo } from 'react';
import { OverlayBoundary } from '../../editor/EditorOverlay/styles';
import { useProductsCards } from '../../../../modals/ProductsSelectModal/ProductsSelectModal';
import { API } from '@brg/api';
import MultipleColumn from '../../editor/ProductsEditBlock/components/MultipleColumn';
import queryString from 'query-string';
import { GeneralEditorOverlay } from '../../editor/EditorOverlayNew/GeneralEditorOverlay';
import useCommonProps from '../../../../../hooks/useCommonProps';
var ProductsBlock = function (props) {
    var post = props.post, cardIds = props.cardIds, isEditable = props.isEditable, dragHandleProps = props.dragHandleProps, onChange = props.onChange, specBlockProps = props.specBlockProps;
    //@ts-ignore
    var isFeed = useCommonProps().isFeed;
    var requestsDisabled = !(cardIds === null || cardIds === void 0 ? void 0 : cardIds.length);
    var cardsQueryString = useMemo(function () {
        // @ts-ignore
        return queryString.stringify({
            cardOnlyImage: true,
            status: [2],
            cardIds: cardIds,
            isHeaderIgnored: true,
            isLite: 'true',
            limit: 50
        });
    }, [cardIds]);
    var data = useProductsCards(cardsQueryString, requestsDisabled).data;
    var cardsSorted = useMemo(function () {
        if (cardIds === null || cardIds === void 0 ? void 0 : cardIds.length) {
            var sortingIndex_1 = cardIds.reduce(function (acc, cardId, index) {
                var _a;
                return __assign(__assign({}, acc), (_a = {}, _a[cardId] = index, _a));
            }, {});
            // @ts-ignore
            if (data === null || data === void 0 ? void 0 : data.data) {
                // @ts-ignore
                var cards = API.lang(data === null || data === void 0 ? void 0 : data.data, 'en');
                var sorted = __spreadArray([], cards, true).sort(function (a, b) {
                    if (sortingIndex_1[a.entityId] > sortingIndex_1[b.entityId]) {
                        return 1;
                    }
                    if (sortingIndex_1[a.entityId] < sortingIndex_1[b.entityId]) {
                        return -1;
                    }
                    return 0;
                });
                return sorted;
            }
            return [];
        }
        return [];
    }, [data, cardIds]);
    // const commentController = useMemo(() => {
    //   return (
    //     <CommentViewController postEntityId={post?.postId} />
    //   )
    // } , [post])
    if (!(cardsSorted === null || cardsSorted === void 0 ? void 0 : cardsSorted.length) && !isEditable) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(OverlayBoundary, { className: 'white-post-block products-block' },
            React.createElement(GeneralEditorOverlay, { isEditable: isEditable, post: post, withoutDrag: isFeed, dragHandleProps: dragHandleProps }),
            React.createElement(MultipleColumn, { cards: cardsSorted, isEditable: isEditable && !post, onChange: onChange, specBlockProps: specBlockProps }))));
};
export default ProductsBlock;
//# sourceMappingURL=ProductsBlock.js.mapvar __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useMemo } from 'react';
import { OverlayBoundary } from '../../editor/EditorOverlay/styles';
import { useProductsCards } from '../../../../modals/ProductsSelectModal/ProductsSelectModal';
import { API } from '@brg/api';
import MultipleColumn from '../../editor/ProductsEditBlock/components/MultipleColumn';
import queryString from 'query-string';
import { GeneralEditorOverlay } from '../../editor/EditorOverlayNew/GeneralEditorOverlay';
import useCommonProps from '../../../../../hooks/useCommonProps';
var ProductsBlock = function (props) {
    var post = props.post, cardIds = props.cardIds, isEditable = props.isEditable, dragHandleProps = props.dragHandleProps, onChange = props.onChange, specBlockProps = props.specBlockProps;
    //@ts-ignore
    var isFeed = useCommonProps().isFeed;
    var requestsDisabled = !(cardIds === null || cardIds === void 0 ? void 0 : cardIds.length);
    var cardsQueryString = useMemo(function () {
        // @ts-ignore
        return queryString.stringify({
            cardOnlyImage: true,
            status: [2],
            cardIds: cardIds,
            isHeaderIgnored: true,
            isLite: 'true',
            limit: 50
        });
    }, [cardIds]);
    var data = useProductsCards(cardsQueryString, requestsDisabled).data;
    var cardsSorted = useMemo(function () {
        if (cardIds === null || cardIds === void 0 ? void 0 : cardIds.length) {
            var sortingIndex_1 = cardIds.reduce(function (acc, cardId, index) {
                var _a;
                return __assign(__assign({}, acc), (_a = {}, _a[cardId] = index, _a));
            }, {});
            // @ts-ignore
            if (data === null || data === void 0 ? void 0 : data.data) {
                // @ts-ignore
                var cards = API.lang(data === null || data === void 0 ? void 0 : data.data, 'en');
                var sorted = __spreadArray([], cards, true).sort(function (a, b) {
                    if (sortingIndex_1[a.entityId] > sortingIndex_1[b.entityId]) {
                        return 1;
                    }
                    if (sortingIndex_1[a.entityId] < sortingIndex_1[b.entityId]) {
                        return -1;
                    }
                    return 0;
                });
                return sorted;
            }
            return [];
        }
        return [];
    }, [data, cardIds]);
    // const commentController = useMemo(() => {
    //   return (
    //     <CommentViewController postEntityId={post?.postId} />
    //   )
    // } , [post])
    if (!(cardsSorted === null || cardsSorted === void 0 ? void 0 : cardsSorted.length) && !isEditable) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(OverlayBoundary, { className: 'white-post-block products-block' },
            React.createElement(GeneralEditorOverlay, { isEditable: isEditable, post: post, withoutDrag: isFeed, dragHandleProps: dragHandleProps }),
            React.createElement(MultipleColumn, { cards: cardsSorted, isEditable: isEditable && !post, onChange: onChange, specBlockProps: specBlockProps }))));
};
export default ProductsBlock;
//# sourceMappingURL=ProductsBlock.js.map